/**
 * Prueba-de-JS anti-bot: token `tk` derivado del campo `ts`.
 * Los PHP (contact / lead-cotizacion / download-script) rechazan en silencio
 * cualquier POST sin ts+tk válidos — un bot que postea directo al endpoint
 * sin ejecutar este código no puede fabricarlos.
 * Espejo del cálculo en PHP: base_convert(ts % 999983, 10, 36).
 */
export function appendFormToken(data: FormData): void {
  const ts = Number(data.get('ts') ?? 0)
  data.set('tk', (ts % 999983).toString(36))
}
